import { render, staticRenderFns } from "./sToolbarPersonBQ.vue?vue&type=template&id=42430c20"
import script from "./sToolbarPersonBQ.vue?vue&type=script&lang=js"
export * from "./sToolbarPersonBQ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports